const projectsData = [
	{
		id: 1,
		title: "SoilTrackers",
		link: "https://www.soiltrackers.com/",
		tags: ["NestJs", "Reactjs", "RabbitMQ", "Redis", "AWS"],
		description:
			"SoilTrackers have a state-of-the-art tracking system. This system meticulously traces and records the movement of soil, waste materials, and invasive species, ensuring transparency and adherence to municipal regulations.",
	},
	{
		id: 2,
		title: "Pillup",
		link: "https://pillup.com/",
		tags: ["Reactjs", "Nodejs", "PostgreSQL", "Express", "Redis", "AWS"],
		description:
			"PillUp is an online pharmacy that sorts your medications into easy to tear pouches by time and date and delivers them to your door.",
	},
	{
		id: 3,
		title: "Booking System",
		link: "https://github.com/avikaldarolia/booking-system",
		tags: ["Reactjs", "Nodejs", "Express", "Google API", "PostgreSQL"],
		description:
			"A smart scheduling platform with role-based access, Google Calendar integration, and employee availability management. It includes a reporting dashboard for weekly insights on budgets and hours, powered by a fast Node.js and PostgreSQL backend.",
	},
	{
		id: 4,
		title: "Movie",
		link: "https://github.com/avikaldarolia/movie-frontend",
		tags: ["Reactjs", "Cookies", "Nodejs", "PostgreSQL", "Express"],
		description:
			"A dynamic platform for movie enthusiasts to search for movies/TV shows, create and manage personalized playlists, and connect with others through a friend request system.",
	},
	// {
	//     id: 4,
	//     title: 'Instagram Clone',
	//     link: 'https://insta-gram-clone-avikaldarolia.vercel.app/login',
	//     tags: ["Reactjs", "TailwindCSS", "Firebase"],
	//     description: 'Cloned Instagram using React and TailWind CSS and deployed it using Firebase. Users can like/dislike and comment on posts and follow other users as well.'
	// }
];

export default projectsData;
